import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, Pause, Play, Tags, X } from "lucide-react";

export default function EeBrandImport() {
    const [cats, setCats] = useState([]);
    const [sel, setSel] = useState(new Set());
    const [job, setJob] = useState(null);

    const loadJob = useCallback(() => api.get("/admin/ee-turbo/brands-job").then(({ data }) => setJob(data)).catch(() => {}), []);
    useEffect(() => {
        api.get("/admin/ee-turbo/categories").then(({ data }) => setCats(data)).catch(() => toast.error("ee-turbo.eu nuk u arrit"));
        loadJob();
    }, [loadJob]);
    useEffect(() => {
        if (!job?.running) return;
        const id = setInterval(loadJob, 2000);
        return () => clearInterval(id);
    }, [job?.running, loadJob]);

    const toggle = (slug) => setSel((s) => { const n = new Set(s); n.has(slug) ? n.delete(slug) : n.add(slug); return n; });
    const start = async () => {
        try {
            await api.post("/admin/ee-turbo/brands-import", { slugs: [...sel] });
            setJob((j) => ({ ...(j || {}), running: true, paused: false, cats_done: 0, cats_total: sel.size, assigned: 0, log: [] }));
        } catch (e) {
            toast.error(e.response?.data?.detail || "Nuk u nis");
        }
    };
    const act = (a) => api.post(`/admin/ee-turbo/brands-job/${a}`).then(({ data }) => setJob(data));
    const allOn = cats.length > 0 && cats.every((c) => sel.has(c.slug));

    return (
        <section className="border border-slate-200 p-4 mb-6 max-w-3xl" data-testid="ee-brand-import">
            <div className="flex items-center gap-2 font-display font-black uppercase mb-1"><Tags className="w-4 h-4" /> Import brande nga ee-turbo</div>
            <p className="text-xs text-slate-500 mb-3">Merr prodhuesit e turbinave (Garrett, Holset, BorgWarner…) për kategoritë e zgjedhura dhe i vendos te artikujt që nuk kanë brand. Artikujt me brand të vendosur nuk preken.</p>
            <div className="flex flex-wrap gap-1.5 mb-3 max-h-40 overflow-y-auto" data-testid="ee-brand-cats">
                <button onClick={() => setSel(allOn ? new Set() : new Set(cats.map((c) => c.slug)))} className="text-[11px] font-mono px-2 py-1 border border-slate-300" data-testid="ee-brand-cats-all">
                    {allOn ? "Hiq të gjitha" : "Zgjidh të gjitha"}
                </button>
                {cats.map((c) => (
                    <label key={c.slug} className={`text-[11px] font-mono px-2 py-1 border cursor-pointer select-none ${sel.has(c.slug) ? "!bg-[hsl(var(--primary))] !text-white !border-[hsl(var(--primary))]" : "border-slate-200"}`} data-testid={`ee-brand-cat-${c.slug}`}>
                        <input type="checkbox" className="hidden" checked={sel.has(c.slug)} onChange={() => toggle(c.slug)} />{c.name}
                    </label>
                ))}
            </div>
            <button onClick={start} disabled={!sel.size || job?.running} className="btn-primary" data-testid="ee-brand-start">
                {job?.running ? <Loader2 className="w-4 h-4 animate-spin" /> : <Tags className="w-4 h-4" />} Importo brandet ({sel.size})
            </button>
            {(job?.running || job?.finished_at) && (
                <div className="mt-3 border border-slate-200 bg-slate-50 p-3 font-mono text-xs space-y-2" data-testid="ee-brand-job">
                    <div className="flex items-center justify-between gap-2 flex-wrap">
                        <span>
                            {job.running ? (job.paused ? <b className="text-amber-600">● PAUZË</b> : <b className="text-emerald-600">● DUKE PUNUAR</b>) : job.cancelled ? <b className="text-red-600">● ANULUAR</b> : <b>● PËRFUNDOI</b>}
                            {" "}Kategori {job.cats_done}/{job.cats_total} · {job.category || ""}{job.manufacturer ? ` · ${job.manufacturer}` : ""}
                            {" "}· <span className="text-emerald-700">u vendosën {job.assigned}</span> · kishin brand {job.already} · brande të reja {job.brands_created}
                        </span>
                        {job.running && (
                            <span className="flex gap-1">
                                {job.paused
                                    ? <button onClick={() => act("resume")} className="btn-primary !py-1 !text-[10px]" data-testid="ee-brand-resume"><Play className="w-3 h-3" /> Vazhdo</button>
                                    : <button onClick={() => act("pause")} className="btn-outline !py-1 !text-[10px]" data-testid="ee-brand-pause"><Pause className="w-3 h-3" /> Pauzë</button>}
                                <button onClick={() => act("cancel")} className="btn-outline !py-1 !text-[10px]" data-testid="ee-brand-cancel"><X className="w-3 h-3" /> Anulo</button>
                            </span>
                        )}
                    </div>
                    {job.error && <div className="text-red-600">{job.error}</div>}
                    {job.log?.length > 0 && <div className="max-h-28 overflow-y-auto text-slate-500">{job.log.map((l, i) => <div key={i}>{l}</div>)}</div>}
                </div>
            )}
        </section>
    );
}
